export const FETCH_BOOTHS = "FETCH_BOOTHS";
export const fetchBoothsAction = (booths) => {
  return {
    type: "FETCH_BOOTHS",
    payload: booths,
  };
};
export const FETCH_SELECTED_BOOTH = "FETCH_SELECTED_BOOTH";
export const fetchSelectedBoothAction = (booths) => {
  return {
    type: "FETCH_SELECTED_BOOTH",
    payload: booths,
  };
};

export const DELETE_BOOTH = "DELETE_BOOTH";
export const deleteBoothAction = (booths) => {
  return {
    type: "DELETE_BOOTH",
    payload: booths,
  };
};

export const SET_BOOTH_ID = "SET_BOOTH_ID";
export const setBoothIdAction = (boothState) => {
  return {
    type: "SET_BOOTH_ID",
    payload: {
      boothId: boothState.boothId,
    },
  };
};

export const INIT_BOOTH_ID = "INIT_BOOTH_ID";
export const initBoothIdAction = () => {
  return {
    type: "INIT_BOOTH_ID",
    payload: {
      boothId: "",
    },
  };
};
